<h4 class="text-muted">FujanaCMS</h4>
<h2 class="mb-4">Herzlich Willkommen!</h2>

<p>Dieses Tool befindet sich noch in der Entwicklung. Bitte eventuelle Fehler notieren und mitteilen.</p>

<p>Um zu beginnen, wählen Sie aus der linken Navigationsleiste eine entsprechende Seite aus.</p>
